import { Text } from '$components'

export type ColourCellProps = {
  colour: string,
  name: string,
}

export function ColourCell({ colour, name }: ColourCellProps) {

  return (
    <div className="flex items-center gap-2">
      <div
        style={{ backgroundColor: colour }}
        className="size-5 min-w-5 min-h-5 rounded-lg"
      />

      <Text
        type="s"
        className="text-nowrap"
      >
        { name }
      </Text>
    </div>

  )
}
